import { Typography } from 'antd'
import React from 'react'
import { ParagraphProps } from 'antd/es/typography/Paragraph'

export function Paragraph({ children }: ParagraphProps) {
    return <Typography.Paragraph type="secondary">{children}</Typography.Paragraph>
}
